import { Component, ComponentRef, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { passwordMatchValidator } from '../../shared/utils/mustMatchValidators';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { Router, ActivatedRoute } from '@angular/router';
import { ExternalUserChangePassword } from '../../domain/model/account/externalUserChangePassword';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { NotificationComponent } from '../../shared/notification/notification.component';
import { ComponentPortal } from '@angular/cdk/portal';
import { NotificationType } from '../../domain/model/enums/notificationType';
import { CreatePassword } from '../../domain/model/account/createPassword';
import { AccountService } from '../../domain/service/accountService';

@Component({
  selector: 'app-create-new-password',
  templateUrl: './create-new-password.component.html',
  styleUrl: './create-new-password.component.css'
})
export class CreateNewPasswordComponent implements OnInit{
  constructor(private readonly router: Router,
    private readonly localStorage: LocalStorageService,
    private readonly accountService: AccountService,private overlay: Overlay,private readonly route: ActivatedRoute) {
}
  ngOnInit(): void {
    this.overlayRef = this.overlay.create({
      hasBackdrop: false,
      positionStrategy: this.overlay
        .position()
        .global()
        .top("20px")
        .right("30px"),
    });
    this.route.queryParams.subscribe(params => {
      this.email = decodeURIComponent(params['email']??'');
      this.token = params['token']??'';
      // use id as needed
    });
  }
private overlayRef!: OverlayRef;

  hide = true;
  hideC = true;
  strongPassword = false;
  email: string = '';
  working = false;
  token: string = ''
  signupForm = new FormGroup({
    password: new FormControl(null, [
      Validators.minLength(8),
      Validators.required,
    ]),
    confirmPassword: new FormControl(null, [
      Validators.minLength(8),
      Validators.required,
      
    ]),
  } ,{validators: passwordMatchValidator('password', 'confirmPassword')});

  onPasswordStrengthChanged(event: boolean) {
    this.strongPassword = event;
  }

  get passwordMismatch() {
    let confirmPassword =  this.signupForm.get('confirmPassword')?.value ?? '';
    return this.signupForm.hasError('passwordMismatch') && (confirmPassword.length > 0);
  }

  onPasswordChange(){
    let changePasswowrd : CreatePassword = {
      email: this.email,
      password: this.signupForm.get('password')?.value ?? '',
      token: this.token
    }
    try {

      this.accountService.setNewPassword(changePasswowrd).subscribe({
        next: (response) => {
      
        },
        error: (error) => {
          this.showNotification('An error ocurred on account creation. Please check the code and try again.', 'Create Password', NotificationType.Error);
       
        },
        complete :() =>{
          this.showNotification('Your confirmation code was correct.', 'Create Password', NotificationType.Success);
          this.router.navigate(['/login']); 
        }
      }); 
      //this.router.navigate(['/login']); 
    
    } catch(e) {
      console.log(e); 
    }
  

  }
  showNotification(message: string, title: string, Success: NotificationType): void {
    // Create a Portal instance of our `NotificationComponent`
    const notificationPortal = new ComponentPortal(NotificationComponent);
    // Attach our `NotificationComponent` to the Overlay Portal
    const notificationRef: ComponentRef<NotificationComponent> =
      this.overlayRef.attach(notificationPortal);
    // Now we can access the component instance
    // and we can pass input for the `message` prop we created.
    notificationRef.instance.message = message;
    notificationRef.instance.title = title;
    notificationRef.instance.type = NotificationType.Success;
    notificationRef.instance.overlayRef = this.overlayRef;
    notificationRef.instance.getColor();
    
    // Set a timeout to detach our component from the overlay
    // after 3000 milliseconds
    setTimeout(() => {
      this.overlayRef.detach();
    }, 3000);
  }
 
  backToLogin(){
    this.router.navigate(['/codeVerification' , this.email]); 
  }
}
